import React, { useState, useEffect } from 'react';
import { DataGrid } from '@mui/x-data-grid';
import { Box, CircularProgress, Grid, Stack, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { getStatisticheMonitoraggio } from '../services/getStatisticheMonitoraggio';
import Header from '../UI/Header';
import * as XLSX from 'xlsx';
import { StyledButton } from '../UI/StyledButton';

const StatisticheMonitoraggio = () => {
  const [statistiche, setStatistiche] = useState(null);
  const theme = useTheme();
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    getStatisticheMonitoraggio()
      .then((data) => {
        setStatistiche(data);
        setIsLoading(false);
      })
      .catch((error) => {
        console.error(error);
      });
  }, []);

  const columns = [
    { field: 'ndg', headerName: 'NDG', flex: 0 },
    { field: 'codiceFiscale', headerName: 'Codice Fiscale', flex: 0, minWidth: 150 },
    { field: 'ragioneSociale', headerName: 'Ragione Sociale', flex: 1, minWidth: 180 },
    { field: 'praticheAperte', headerName: 'Aperte', flex: 0, align: 'center', headerAlign: 'center' },
    { field: 'praticheChiuse', headerName: 'Chiuse', flex: 0, align: 'center', headerAlign: 'center' },
    { field: 'praticheAdvInCorso', headerName: 'ADV in Corso', flex: 0, minWidth: 130, align: 'center', headerAlign: 'center' },
    { field: 'creatoAdv', headerName: 'Creato ADV', flex: 0, align: 'center', headerAlign: 'center' },
  ];

  const exportToExcel = () => {
    const ws = XLSX.utils.json_to_sheet(statistiche?.elencoMonitoraggi.map(item => ({
      NDG: item.ndg,
      'Codice Fiscale': item.codiceFiscale,
      'Ragione Sociale': item.ragioneSociale,
      'Pratiche Aperte': item.praticheAperte,
      'Pratiche Chiuse': item.praticheChiuse,
      'Pratiche ADV in Corso': item.praticheAdvInCorso,
      'Creato ADV': item.creatoAdv,
    })));

    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Statistiche Monitoraggio');
    XLSX.writeFile(wb, 'Statistiche_Monitoraggio.xlsx');
  };

  const rows = statistiche?.elencoMonitoraggi.map((monitoraggio, index) => ({
    id: index,
    ...monitoraggio,
  }));

  return (
    <div>
      <Stack>
        <Header
          showHome={true}
          showRichiesta={false}
          showStatistiche={false}
          showMonitoraggio={true}
          header={
            <Grid
              container
              justifyContent="center"
              alignItems="center"
              sx={{
                textAlign: 'center',
                height:'140px'
              }}
            >
              <Typography
                sx={{ flexGrow: 1 }}
                color={theme.palette.black.main}
                variant="h1"
              >
                ACCOUNTING MONITORAGGIO
              </Typography>
            </Grid>
          }
        />
        {isLoading ? (
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              height: '100vh',
            }}
          >
            <CircularProgress />
          </Box>
        ) : (
          <Box sx={{ marginLeft: '2.5%', marginRight: '2.5%' }}>
            <Typography variant="h3" sx={{ marginBottom: '2rem' }}>
              Statistiche Globali:
            </Typography>
            <Grid container spacing={2} alignItems="flex-end">
              <Grid item xs={12} md={10}>
                <div style={{ paddingLeft: '10px', paddingBottom: '5px' }}>
                  <strong>Totale Monitoraggi: </strong>{statistiche.totaleMonitoraggi}
                </div>
                <div style={{ paddingLeft: '10px', paddingBottom: '5px' }}>
                  <strong>Monitoraggi Chiusi: </strong>{statistiche.monitoraggiChiusi}
                </div>
                <div style={{ paddingLeft: '10px', paddingBottom: '5px' }}>
                  <strong>Monitoraggi Aperti: </strong>{statistiche.monitoraggiAperti}
                </div>
                <div style={{ paddingLeft: '10px', paddingBottom: '5px' }}>
                  <strong>Clienti in Monitoraggio: </strong>{statistiche.posizioniUnivocheAperte}
                </div>
              </Grid>
              <Grid item xs={12} md={2} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                <StyledButton
                  variant="contained"
                  color="primary"
                  onClick={exportToExcel}
                >
                  Esporta in Excel
                </StyledButton>
              </Grid>
            </Grid>
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                width: '100%',
                overflowX: 'auto',
                marginTop: '2rem',
              }}
            >
              <Box sx={{ width: '100%', maxWidth: '100%' }}>
                <DataGrid
                  rows={rows}
                  columns={columns}
                  pageSize={10}
                  rowsPerPageOptions={[10]}
                  pagination
                  disableSelectionOnClick
                  autoHeight
                  sx={{
                    '& .MuiDataGrid-columnHeader': {
                      backgroundColor: theme.palette.grey[200],
                    },
                    '& .MuiDataGrid-cell': {
                      fontSize: '14px',
                      textAlign: 'center',
                    },
                  }}
                />
              </Box>
            </Box>
          </Box>
        )}
      </Stack>
    </div>
  );
};

export default StatisticheMonitoraggio;
